import { 
  LOAD_DASHBOARD_DATA_IN_PROGRESS,
  LOAD_DASHBOARD_DATA_SUCCESS,
  LOAD_DASHBOARD_DATA_FAILURE,
  LOAD_DASHBOARD_WIDGETS_LIST_SUCCESS,
  DASHBOARD_OPERATION_COMPLETED,
  LOAD_DASHBOARD_USER_WIDGETS_LIST_SUCCESS
} from "./actions";

const initialState = { isLoading: false, widgetData: [], widgetsList:[], userWidgetsList:[]};

export const dashboardData= (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    
    case LOAD_DASHBOARD_DATA_SUCCESS: {
      const { data } = payload;
      return {
        ...state,
        isLoading: false,
        widgetData: data,
        
      };
    }
    case LOAD_DASHBOARD_DATA_IN_PROGRESS:
      return {
        ...state,
        isLoading: true,
      };
    case LOAD_DASHBOARD_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
      }; 
    case LOAD_DASHBOARD_WIDGETS_LIST_SUCCESS: {
      const { data } = payload;
      return {
        ...state,
        isLoading: false,
        widgetsList: data,
      };
    }
    case LOAD_DASHBOARD_USER_WIDGETS_LIST_SUCCESS: {
      const { data } = payload;
      return {
        ...state,
        isLoading: false,
        userWidgetsList: data,
      };
    }
    case DASHBOARD_OPERATION_COMPLETED:
      return {
          ...state,
          isLoading: false,
      }; 
    default:
      return state;
  }
};
